//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dataops_service from '@/apps/dataops/services/dataops_service';
export default {
  name: 'ImportScript',
  components: {},
  mixins: [],
  data: function data() {
    var _this = this;
    return {
      valid: false,
      hasFile: false,
      File: [],
      fileBase64: null,
      rules: {
        file: [function (v) {
          return !!v || _this.translate('customer_insights.rules.file');
        }, function (v) {
          return !v || v.size < 2000000 || _this.translate('customer_insights.rules.file_size');
        }]
      },
      form: {
        sql_file: null
      },
      viewsData: []
    };
  },
  beforeMount: function beforeMount() {},
  methods: {
    onFileSelected: function onFileSelected() {
      var _this2 = this;
      if (!this.form.sql_file) {
        this.hasFile = false;
        return;
      }
      var reader = new FileReader();
      reader.onload = function (event) {
        _this2.fileBase64 = event.target.result.split(',')[1]; // Get base64 string, remove "data:...;base64,"
        _this2.hasFile = true;
      };
      reader.readAsDataURL(this.form.sql_file);
    },
    dropFile: function dropFile(e) {
      this.File = e.dataTransfer.files;
      if (this.File.length > 0) {
        this.form.sql_file = e.dataTransfer.files[0];
        this.onFileSelected();
      }
    },
    save: function save() {
      var _this3 = this;
      if (this.$refs.form.validate()) {
        var file_string_binary = {
          'script_base64': this.fileBase64
        };
        dataops_service.importScripts(file_string_binary).then(function (response) {
          _this3.isLoading = false;
        });
      }
    }
  },
  computed: {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    }
  }
};